/* VS GAMING SUPPORT HERO
   File: assets/vs-gaming-support-hero.js
*/

(function () {
  'use strict';

  function initVsGamingSupportHero(scope) {
    var root = scope && scope.querySelector
      ? scope.querySelector('.vs-gaming-support-hero')
      : document.querySelector('.vs-gaming-support-hero');

    if (!root) return;

    var image = root.querySelector('.vs-gaming-support-hero__image');
    var mobileImage = root.querySelector('.vs-gaming-support-hero__mobile-image');
    var images = [image, mobileImage].filter(Boolean);

    images.forEach(function (currentImage) {
      currentImage.addEventListener('load', function () {
        root.classList.add('vs-gaming-support-hero--ready');
      }, { once: true });
      if (currentImage.complete) {
        root.classList.add('vs-gaming-support-hero--ready');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVsGamingSupportHero(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVsGamingSupportHero(event.target);
  });
})();
